import { render, staticRenderFns } from "./confirmPopup.vue?vue&type=template&id=bceb3f06&scoped=true"
import script from "./confirmPopup.vue?vue&type=script&lang=js"
export * from "./confirmPopup.vue?vue&type=script&lang=js"
import style0 from "./confirmPopup.vue?vue&type=style&index=0&id=bceb3f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceb3f06",
  null
  
)

export default component.exports